import { estruturaItensMap } from '../risrotEstruturaCatalog';
import RisrotEstruturaTable from './RisrotEstruturaTable';
import type { RisrotEstruturaBaseProps } from './RisrotEstruturaTable';

const ESTRUTURA = 'Talude de montante' as const;

export default function EstruturaTaludeMontante(props: RisrotEstruturaBaseProps) {
	return (
		<RisrotEstruturaTable
			{...props}
			structureName={ESTRUTURA}
			fixedItems={estruturaItensMap[ESTRUTURA]}
		/>
	);
}
